import React from 'react';
import { Grid } from '@mui/material';

import {
	BooleanDescField,
	DateTimeField,
	SimpleTextField,
	SwitchField,
	TagsSelectField,
	useSettings,
	useUserData
} from 'app/main/components';
import { type DetailsSectionInfoContentProps } from 'app/main/components/page-layouts';

export default function CommunicationsDetailsSectionInfo(props: DetailsSectionInfoContentProps) {
	const { t } = useSettings();
	const userData = useUserData();

	return (
		<>
			<Grid size={12}>
				{/* TITLE */}
				<SimpleTextField
					name="coms_title"
					label={t('DETAILS_COMMUNICATIONS_FIELD_TITLE')}
					value={props.model.coms_title}
					isEdit={props.isEdit}
					sendChange={props.sendChange}
					logProps={props.logProps}
					required
					validationError={t('ERROR_TEXT_REQUIRED')}
				/>
			</Grid>
			<Grid size={{ sm: 6, xs: 12 }}>
				{/* DATE and TIME */}
				<DateTimeField
					name="coms_d_from"
					label={t('DETAILS_COMMUNICATIONS_FIELD_DATE_FROM')}
					value={props.model.coms_d_from}
					isEdit={props.isEdit}
					sendChange={props.sendChange}
					logProps={props.logProps}
					required
					validationError={t('ERROR_TEXT_REQUIRED')}
				/>
			</Grid>
			<Grid size={{ sm: 6, xs: 12 }}>
				{/* DATE TO */}
				<DateTimeField
					name="coms_d_to"
					label={t('DETAILS_COMMUNICATIONS_FIELD_DATE_TO')}
					value={props.model.coms_d_to}
					isEdit={props.isEdit}
					sendChange={props.sendChange}
					logProps={props.logProps}
				/>
			</Grid>
			<Grid size={{ xs: 12 }}>
				{/* TAGS */}
				<TagsSelectField
					name="coms_tags"
					label={t('DETAILS_COMMUNICATIONS_FIELD_TAGS')}
					value={props.model.coms_tags}
					isEdit={props.isEdit}
					sendChange={props.sendChange}
					logProps={props.logProps}
				/>
			</Grid>
			<Grid size={{ sm: 6, xs: 12 }}>
				{/* WARNING */}
				<BooleanDescField
					name="coms_warning_desc"
					label={t('DETAILS_COMMUNICATIONS_FIELD_WARNING')}
					value={props.model.coms_warning_desc}
					icon="alert-outline"
					color="warning.main"
					isEdit={props.isEdit}
					sendChange={props.sendChange}
					logProps={props.logProps}
				/>
			</Grid>
			<Grid size={{ sm: 6, xs: 12 }}>
				{/* BLOCKED */}
				<BooleanDescField
					name="coms_blocked_desc"
					label={t('DETAILS_COMMUNICATIONS_FIELD_BLOCKED')}
					value={props.model.coms_blocked_desc}
					icon="cancel"
					color="error.main"
					isEdit={props.isEdit}
					sendChange={props.sendChange}
					logProps={props.logProps}
				/>
			</Grid>
			<Grid size={{ sm: 6, xs: 12 }}>
				{/* ACTIVE */}
				<SwitchField
					name="coms_active"
					label={t('DETAILS_COMMUNICATIONS_FIELD_ACTIVE')}
					value={props.model.coms_active}
					isEdit={props.isEdit}
					sendChange={props.sendChange}
					logProps={props.logProps}
				/>
			</Grid>
			<Grid size={{ sm: 6, xs: 12 }}>
				{/* READ NOTIFICATION */}
				<SwitchField
					name="coms_readnotification"
					label={t('DETAILS_COMMUNICATIONS_FIELD_READNOTIFICATION')}
					value={props.model.coms_readnotification}
					isEdit={props.isEdit}
					sendChange={props.sendChange}
					logProps={props.logProps}
				/>
			</Grid>
		</>
	);
}
